import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step4 } from '../../../../../shared/models/component-messages/simp_at/step4';
import { AttributionFromFNSimple } from '../../models/AttributionFromFNSimple';

@Component({
	selector: 'app-step4',
	templateUrl: './step4.component.html'
})
export class Step4Component implements OnInit {
	@Input() fnSimpleAttribution: AttributionFromFNSimple;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() uid = '';
	@Input() linkForRouter: string;

	public step4 = new Step4();

	constructor() {}

	public ngOnInit() {}

	public getUid() {
		return this.uid;
	}
}
